export const gtagScript = (id) => `
  <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=${id}"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${id}');
  </script>
`

export const gtagInjectBodyScript = (id) => {
  // Load Tag Manager script.
  const gtmScript = document.createElement('script')
  gtmScript.async = true
  gtmScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`

  const firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(gtmScript, firstScript)
}

export const gtagEvent = (id, event, options = {}) => {
  const fired = window.dataLayer
    .filter((item) => item[0] === 'config')
    .find((item) => item[1] === id)

  if (!fired) {
    window.gtag('config', id)
  }

  if (event) {
    window.gtag('event', event, options)
  }
}
